// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import AuditClaimFacets from './facets';
import ClaimsList from './claims-list';
import Facets from '../state/facets';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import RefinableListWidget from '../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../shared/state/search-filters';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import sortOptions from '../constants/sort-options';

function handleApplyFilters() {

    this.actions.readClaims(this.queryParams.query.d, this.facets, this.searchFilters);

}

function handleFilterByChange(filterBy) {

    this.actions.updateListFilterBy(this.claims, filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateListSortBy(this.claims, sortBy, this.searchFilters.sortDirection);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateListSortDirection(this.claims, this.searchFilters.sortBy, sortDirection);

}

class ClaimSearch extends Component {

    componentWillMount() {

        this.props.actions.readProductHierarchy();
        this.props.actions.initializeComponent(this.props.queryParams.query.d, this.props.searchFilters);

    }

    render() {

        return (
            <section className='add-claims-to-audit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside>
                    <AuditClaimFacets onApplyFilters={this.props::handleApplyFilters}/>
                </aside>
                <main className='main'>
                    <div className='back-to-audit'>
                        <Link
                            className='button-primary'
                            to={`/tcsm/audits/prepare${this.props.queryParams.search}`}
                        >
                            <FormattedMessage id='BACK_TO_AUDIT'/>
                        </Link>
                    </div>
                    <section className='add-claims-to-audit-results'>
                        <RefinableListWidget
                            onFilterByChange={this.props::handleFilterByChange}
                            onSortByChange={this.props::handleSortByChange}
                            onSortDirectionChange={this.props::handleSortDirectionChange}
                            searchFilters={this.props.searchFilters}
                            sortOptions={sortOptions}
                        />
                        <ClaimsList
                            auditClaims={this.props.auditClaims}
                            claims={this.props.claimsFiltered}
                            handleAddClaim={this.props.actions.addClaimToAudit}
                            handleRemoveClaim={this.props.actions.removeClaimFromAudit}
                            isInitialLoad={this.props.isInitialLoad}
                        />
                    </section>
                </main>
            </section>
        );

    }

}

ClaimSearch.displayName = 'ClaimSearch';
ClaimSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    auditClaims: PropTypes.arrayOf(PropTypes.instanceOf(AuditClaim)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(AuditClaim)).isRequired,
    claimsFiltered: PropTypes.arrayOf(PropTypes.instanceOf(AuditClaim)).isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};

export default ClaimSearch;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/index.js